/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergenzaAssistitoAddByFilterDTO
 */
export interface EmergenzaAssistitoAddByFilterDTO {
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoAddByFilterDTO
     */
    enteId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoAddByFilterDTO
     */
    filtroId?: string;
}

/**
 * Check if a given object implements the EmergenzaAssistitoAddByFilterDTO interface.
 */
export function instanceOfEmergenzaAssistitoAddByFilterDTO(value: object): value is EmergenzaAssistitoAddByFilterDTO {
    return true;
}

export function EmergenzaAssistitoAddByFilterDTOFromJSON(json: any): EmergenzaAssistitoAddByFilterDTO {
    return EmergenzaAssistitoAddByFilterDTOFromJSONTyped(json, false);
}

export function EmergenzaAssistitoAddByFilterDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergenzaAssistitoAddByFilterDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'enteId': json['enteId'] == null ? undefined : json['enteId'],
        'filtroId': json['filtroId'] == null ? undefined : json['filtroId'],
    };
}

export function EmergenzaAssistitoAddByFilterDTOToJSON(value?: EmergenzaAssistitoAddByFilterDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enteId': value['enteId'],
        'filtroId': value['filtroId'],
    };
}

